import 'bootstrap/js/dist/modal';

(function($) {
    if ($('.video-modal__link--button').length > 0) {
        $('.video-modal__link--button').on('click', function(e) {
            e.preventDefault();
        });
    }

    $('.modal').on('hide.bs.modal hidden.bs.modal', function() {
        // Quitar el src para pausar el video sin reiniciarlo
        const $iframe = $(this).find('iframe');
        $iframe.each(function() {
            // Solo guardar el src si data-src no existe
            if (!$(this).attr('data-src')) {
                $(this).attr('data-src', $(this).attr('src'));
            }
            $(this).attr('src', '');
        });
    });

    $('.modal').on('show.bs.modal', function() {
        // Restaurar el src al abrir el modal
        const $iframe = $(this).find('iframe');
        $iframe.each(function() {
            const src = $(this).attr('data-src');
            if (src && src !== '') {
                $(this).attr('src', src);
                $(this).removeAttr('data-src');
            }
        });
    });
})(jQuery);
